import type { MailServer } from '@/services/db/mail-server/entity';
import type { MailServerDefaultFor } from '@/services/db/mail-server/mutations';

/** The routing value that sends every kind of email through a server. */
const DEFAULT_FOR_ALL: MailServerDefaultFor = 'all';

/**
 * Whether all email of the workspace goes through custom SMTP. Such a workspace
 * does not need a verified sending domain. A server that gets only some kinds of
 * email does not count, because the other kinds still go through Customer.io.
 */
export function sendsAllEmailThroughCustomSmtp(servers: readonly MailServer[], isCustomSmtpLocked: boolean): boolean {
  if (isCustomSmtpLocked) {
    return true;
  }
  return servers.some((server) => server.default_for === DEFAULT_FOR_ALL);
}
